import { SkullIcon } from '@/components/game/GameIcons'
import { defensiveTier } from '@/lib/danger'

/**
 * Shared danger readout for raids SUFFERED (defence side). Renders the RAW danger
 * value — no "/5" — so reputation-driven NPC pressure (now uncapped, ~12+) stays
 * legible instead of pegging at a 5-skull ceiling. A single skull + the number +
 * a neutral severity label (Escarmouche → Raid → Flotte → Armada), tinted by the
 * defensive tier. Used by DefensePanel (NextRaid) and Map (IncomingEta) so the
 * threat reads the same everywhere.
 */
export function DangerBadge({ danger }: { danger: number }) {
  const tier = defensiveTier(danger)
  return (
    <span
      className={`inline-flex items-center gap-1 tabular-nums ${tier.tone}`}
      title={`Danger ${danger} (${tier.label})`}
    >
      <SkullIcon className="w-3.5 h-3.5" />
      <span className="font-semibold">{danger}</span>
      <span className="text-[0.65rem] uppercase tracking-wider opacity-90">{tier.label}</span>
    </span>
  )
}
